import {
  IEnableWhen,
  IImageUrls,
  InputType,
  QuestionnaireType,
} from "@gloria-public/questionnaire/domain/interfaces/questionnaire-common.interface";
import { ICoding, IIdentifierFhir, IReferenceFhir } from "@shared/interfaces/shared.interface";
import { ITranslation } from "@shared/utils/helpers/translation.interface";

export interface INewQuestionnaireResponse {
  questionnaire: IReferenceFhir; // Value is "{questionnaireID}/{language}"
  questionnairePublicationDate: string;
  subject?: IReferenceFhir | null;
}

export interface IQuestionnaireResponseSerializable {
  resourceType: string;
  identifier: IIdentifierFhir;
  questionnaire: IReferenceFhir;
  status: QRStatus;
  subject: IReferenceFhir;
  author: IReferenceFhir;
  authored: string;
  group: IAnswersGroup;
  source: IReferenceFhir;
  specificUse: QuestionnaireType;
  successThreshold?: number;
  knowledgeId?: string;
  mediaId?: string;
  knowledgePublicationDate?: string;
  questionnairePublicationDate: string;
  questionByGroup: boolean;
  scoring: IResponseScoringSerializable;
}

export interface IResponseScoringSerializable {
  score?: number;
  interpretation?: IScoringInterpretationSerializable;
}

export interface IAnswerToQuestion {
  questionnaireResponse: string;
  questionnaireDate: string;
  subject?: string | null;
  status: QRStatus;
  linkID: string;
  answer: IAnswer[];
}

export interface IAnswersGroup {
  linkId: string;
  title: string;
  subject?: IReferenceFhir;
  text: string;
  question?: IAnswersQuestion[];
  group?: IAnswersGroup[];
}

export interface IAnswersQuestion {
  linkId: string;
  text: string;
  imageUrls?: IImageUrls[];
  enableWhen?: IEnableWhen[];
  inputType?: InputType;
  answer: IAnswer[];
}

export interface IAnswer {
  valueCoding: ICoding;
}

export interface INextStepsAfterQuestionnaire {
  interpretation?: IScoringInterpretationSerializable;
  nextSteps: IRuleResultSerializable[];
  score?: number;
  dna?: IDnaNextSteps;
}

export interface IDnaNextSteps {
  hasDNA: boolean;
  latestDate?: string;
  serviceRequest: string;
  risk: string;
  message: ITranslation;
}

export interface IScoringInterpretationSerializable {
  enableWhen?: IEnableWhen[];
  enableWhenBehavior: string;
  result: ITranslation;
}

export interface IRuleResultSerializable {
  resultType: RuleResultType;
  messageType: MessageType;
  message: ITranslation;
  value?: string;
  variableToInterpolate?: string;
}

export enum QRStatus {
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
}

export enum MessageType {
  MESSAGE = "MESSAGE",
  HTML = "HTML",
  MEDIA = "MEDIA",
}

export enum RuleResultType {
  QUESTIONNAIRE = "QUESTIONNAIRE",
  SERVICE_REQUEST = "SERVICE_REQUEST",
  NONE = "NONE",
}
